var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJbpycharm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_8030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4456 5.02881L31.7714 12.846L28.4342 19.6574L22.7656 18.1031H17.9199L22.4456 5.02881Z",
    fill: "url(#paint0_linear_87_8030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0286 10.1029L11.2 19.6571L11.0171 22.9486L6.49143 24.9143L0 25.6L1.96571 4.89143L13.6686 0L20.8914 4.75429L13.0286 10.1029Z",
    fill: "url(#paint1_linear_87_8030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0286 10.103L13.8971 28.5716L10.9714 32.0002L0 25.6002L9.00571 12.1602L13.0286 10.103Z",
    fill: "url(#paint2_linear_87_8030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0969 8.73143H13.9883L23.8169 0L25.0969 8.73143Z",
    fill: "url(#paint3_linear_87_8030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 28.6171L22.2172 31.9543L9.23438 28.2971L13.0287 10.1029L14.5372 8.73143L22.4458 8L21.7144 15.9543L28.0229 13.5314L32.0001 28.6171Z",
    fill: "url(#paint4_linear_87_8030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12598 6.12549H25.8745V25.8741H6.12598V6.12549Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 22.1714H15.4057V23.4057H8V22.1714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95508 8.73145H11.2465C13.2122 8.73145 14.4008 9.8743 14.4008 11.5657C14.4008 13.44 12.9379 14.4914 11.1094 14.4914H9.73794V16.9143H7.95508L7.95508 8.73145ZM11.1551 12.8457C12.0694 12.8457 12.5722 12.2514 12.5722 11.5657C12.5722 10.7429 12.0236 10.3314 11.1094 10.3314H9.73794V12.8457H11.1551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1318 12.8457C15.1318 10.5142 16.869 8.59424 19.3833 8.59424C20.9376 8.59424 21.8518 9.0971 22.629 9.87424L21.4861 11.2C20.8461 10.6057 20.2061 10.2857 19.3833 10.2857C18.0118 10.2857 17.0061 11.4285 17.0061 12.8457C17.0061 14.2628 17.9661 15.36 19.3833 15.36C20.2976 15.36 20.8918 14.9942 21.5318 14.4L22.6747 15.5428C21.8518 16.4571 20.8918 17.0057 19.3376 17.0057C16.9147 17.0514 15.1318 15.1771 15.1318 12.8457Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_8030",
    x1: 11.4276,
    y1: 12.3641,
    x2: 30.4712,
    y2: 12.3641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_8030",
    x1: -11.227,
    y1: 27.0085,
    x2: 27.9863,
    y2: -1.93875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#A7EB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#5FE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#32DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#20D68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#1ED497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#19D1A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#13CCC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#0BC6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_8030",
    x1: 4.26514,
    y1: 35.4991,
    x2: 10.8055,
    y2: 14.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#24D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#2FD886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#41DA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#5ADC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#7AE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#A1E36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#CFE865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_8030",
    x1: 12.9254,
    y1: 17.6562,
    x2: 27.1581,
    y2: -1.47932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#24D788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#2FD886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#41DA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#5ADD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#79E077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7CE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#8CE173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#B2E56B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_8030",
    x1: 34.6922,
    y1: 20.0914,
    x2: 6.01518,
    y2: 19.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#ECF451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#C2E964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#B2E56B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_8030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJbpycharm);
export default __webpack_public_path__ + "static/media/jbpycharm.ab90196c6e0e7982096aa6a4e19cd63a.svg";
export { ForwardRef as ReactComponent };